import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ExecutionItem} from './execution-item';
import {ExecutionStateEnum} from './execution-state.enum';
import {untilDestroyed} from 'ngx-take-until-destroy';

@Injectable()
export class ExecutionService implements OnDestroy {

    private stateSubject = new BehaviorSubject<ExecutionStateEnum>(ExecutionStateEnum.NotStarted);
    public state$ = this.stateSubject.asObservable();

    private executionItems: ExecutionItem[] = [];

    private executionItemsSubscriptions: Subscription[] = [];

    public start(items: ExecutionItem[]) {
        this.end();

        this.executionItems = items;

        this.executionItems.forEach(item => {
            const itemsSubscription = item.state$
                .pipe(untilDestroyed(this))
                .subscribe(() => {
                    this.checkCurrentStates();
                });

            this.executionItemsSubscriptions.push(itemsSubscription);
        });

        this.setState(ExecutionStateEnum.Running);
    }

    public end() {
        this.executionItemsSubscriptions.forEach((itemsSubscription) => {
            itemsSubscription.unsubscribe();
        });

        this.executionItems = [];
        this.executionItemsSubscriptions = [];

        this.setState(ExecutionStateEnum.NotStarted);
    }

    public get items(): ExecutionItem[] {
        return this.executionItems;
    }

    public ngOnDestroy() {
    }

    private checkCurrentStates() {
        let completed = true;
        let failed = false;

        this.executionItems.forEach(item => {
            if (item.state !== ExecutionStateEnum.Completed) {
                completed = false;
            }
            if (item.state === ExecutionStateEnum.Failed) {
                failed = true;
            }
        });

        if (completed) {
            this.setState(ExecutionStateEnum.Completed);

            return;
        }

        if (failed) {
            this.setState(ExecutionStateEnum.Failed);

            return;
        }

        this.setState(ExecutionStateEnum.Running);
    }

    private setState(state: ExecutionStateEnum) {
        if (this.stateSubject.value === state) {
            return;
        }

        this.stateSubject.next(state);
    }
}
